import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app';
import './shared/style/variables.scss';

const container: any = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
